"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prefixWithZero = void 0;

const prefixWithZero = num => num < 10 ? "0".concat(num) : "".concat(num);

exports.prefixWithZero = prefixWithZero;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJwcmVmaXhXaXRoWmVybyIsIm51bSJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1RpbWVQaWNrZXIvVGltZVBpY2tlci51dGlscy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY29uc3QgcHJlZml4V2l0aFplcm8gPSAobnVtOiBudW1iZXIpID0+IChudW0gPCAxMCA/IGAwJHtudW19YCA6IGAke251bX1gKVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQU8sTUFBTUEsY0FBYyxHQUFJQyxHQUFELElBQWtCQSxHQUFHLEdBQUcsRUFBTixjQUFlQSxHQUFmLGNBQTBCQSxHQUExQixDQUF6QyJ9